import { ReactNode } from 'react';
import { Title, Text, Box } from '@nimbus-ds/components';
import { CATALOG_PRODUCT_HASHED_SLUG } from 'App/featuresFlags';
import { useHasTags } from 'App/hooks';
import { AiNavigationAttributes } from 'commons/hooks';

interface TagAndSeoItemTitleProps {
  children: ReactNode;
  title: string;
  description?: string;
  slot: ReactNode;
  aiNavigationAttributes?: AiNavigationAttributes;
}

function TagAndSeoItemTitle({
  children,
  title,
  description,
  slot,
  aiNavigationAttributes,
}: TagAndSeoItemTitleProps): JSX.Element {
  const [hasCatalogProductHashedSlug] = useHasTags([
    CATALOG_PRODUCT_HASHED_SLUG,
  ]);

  const fontSize = hasCatalogProductHashedSlug ? 'h5' : 'h3';
  const gap = hasCatalogProductHashedSlug ? '2' : '4';

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={gap}
      {...aiNavigationAttributes}
    >
      <Box display="flex" flexDirection="row" gap="2" alignItems="center">
        <Title as="h3" fontSize={fontSize}>
          {title}
        </Title>
        {slot}
      </Box>
      {!!description && <Text>{description}</Text>}
      {children}
    </Box>
  );
}

export default TagAndSeoItemTitle;
